import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-lg border-b border-border">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center gap-4">
          <Link to="/">
            <Button variant="ghost" size="icon" className="rounded-full">
              <ArrowLeft className="w-5 h-5" />
            </Button>
          </Link>
          <Link to="/" className="flex items-center gap-2">
            <span className="text-xl font-display font-bold text-primary">❤️ Flirra</span>
          </Link>
        </div>
      </header>

      <main className="pt-24 pb-16 px-4">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-display font-bold text-foreground mb-2">Brugerbetingelser</h1>
          <p className="text-muted-foreground mb-8">Sidst opdateret: Februar 2026</p>

          <div className="prose prose-slate dark:prose-invert max-w-none space-y-8">
            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">1. Accept af betingelser</h2>
              <p className="text-muted-foreground leading-relaxed">
                Ved at oprette en konto på Flirra accepterer du disse brugerbetingelser. Hvis du ikke accepterer 
                betingelserne, må du ikke bruge vores tjeneste.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">2. Hvem kan bruge Flirra?</h2>
              <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
                <li>Du skal være mindst 18 år gammel</li>
                <li>Du må ikke være gift (medmindre du er separeret)</li>
                <li>Du må ikke være udelukket fra at bruge vores tjenester</li>
                <li>Du skal oprette en konto med sandfærdige oplysninger</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">3. Din konto</h2>
              <p className="text-muted-foreground leading-relaxed">
                Du er ansvarlig for at holde din adgangskode sikker og for al aktivitet på din konto. 
                Du må ikke dele din konto med andre eller oprette flere konti.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">4. Regler for adfærd</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Du accepterer at følge disse regler:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
                <li>Brug ikke stødende, truende eller chikanerende sprog</li>
                <li>Del ikke pornografisk eller ulovligt indhold</li>
                <li>Udgiv dig ikke for andre personer</li>
                <li>Spam ikke andre brugere med uønskede beskeder</li>
                <li>Brug ikke Flirra til kommercielle formål eller svindel</li>
                <li>Respekter andre brugeres privatliv</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">5. Indhold</h2>
              <p className="text-muted-foreground leading-relaxed">
                Du beholder ejerskabet over det indhold, du uploader (billeder, tekst). Ved at uploade 
                indhold giver du Flirra ret til at vise det til andre brugere som en del af tjenesten.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">6. Premium og betalinger</h2>
              <p className="text-muted-foreground leading-relaxed">
                Premium-abonnementer faktureres på forhånd. Se vores <Link to="/sales-terms" className="text-primary hover:underline">handelsbetingelser</Link> for 
                detaljer om fortrydelsesret og refusion.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">7. Opsigelse</h2>
              <p className="text-muted-foreground leading-relaxed">
                Du kan til enhver tid slette din konto via Indstillinger. Vi forbeholder os retten til at 
                suspendere eller slette konti, der overtræder disse betingelser.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">8. Ansvarsfraskrivelse</h2>
              <p className="text-muted-foreground leading-relaxed">
                Flirra er en platform til at møde andre mennesker. Vi garanterer ikke matches, 
                forhold eller ægteskaber. Vi er ikke ansvarlige for andre brugeres adfærd.
                Mød altid nye mennesker på offentlige steder.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">9. Ansvarsbegrænsning</h2>
              <p className="text-muted-foreground leading-relaxed">
                I det omfang loven tillader det, er Flirra ikke ansvarlig for indirekte skader, 
                tab af data eller andre konsekvenser af din brug af tjenesten.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">10. Ændringer</h2>
              <p className="text-muted-foreground leading-relaxed">
                Vi kan opdatere disse betingelser fra tid til anden. Ved væsentlige ændringer 
                informerer vi dig via email eller i appen.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">11. Lovvalg</h2>
              <p className="text-muted-foreground leading-relaxed">
                Disse betingelser er underlagt dansk lov. Eventuelle tvister afgøres ved danske domstole.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">12. Kontakt</h2>
              <p className="text-muted-foreground leading-relaxed">
                Har du spørgsmål? Kontakt os på:{' '}
                <a href="mailto:support@flirra.dk" className="text-primary hover:underline">support@flirra.dk</a>
              </p>
            </section>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-border py-8">
        <div className="max-w-4xl mx-auto px-4 flex flex-wrap gap-6 justify-center text-sm text-muted-foreground">
          <Link to="/privacy" className="hover:text-foreground">Privatlivspolitik</Link>
          <Link to="/terms" className="hover:text-foreground">Brugerbetingelser</Link>
          <Link to="/sales-terms" className="hover:text-foreground">Handelsbetingelser</Link>
        </div>
      </footer>
    </div>
  );
};

export default TermsOfService;
